import FormattedMessage from 'I18n/components/FormattedMessage';
import { ApprovalOperation, ApprovalTypes } from '../../types';
import { UnreachableI18nCaseError } from '../../utils/i18nUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ApprovalModalHeaderI18n(props) {
  const {
    approvalType,
    approvalOperation
  } = props;
  switch (approvalOperation) {
    case ApprovalOperation.REQUEST:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalModalHeader.REQUEST"
      });
    case ApprovalOperation.RECALL:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalModalHeader.RECALL"
      });
    case ApprovalOperation.REJECT:
      {
        if (approvalType === ApprovalTypes.DEAL) {
          return /*#__PURE__*/_jsx(FormattedMessage, {
            message: "productApprovals.ApprovalModalHeader.REJECT.DEAL"
          });
        }
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalModalHeader.REJECT.default"
        });
      }
    case ApprovalOperation.APPROVE:
      return /*#__PURE__*/_jsx(ApprovalModalHeaderI18nApprove, {
        approvalType: approvalType
      });
    default:
      throw new UnreachableI18nCaseError(approvalOperation);
  }
}
function ApprovalModalHeaderI18nApprove(props) {
  const {
    approvalType
  } = props;
  switch (approvalType) {
    case 'MARKETING_EMAIL':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalModalHeader.APPROVE.MARKETING_EMAIL"
      });
    case 'SITE_PAGE':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalModalHeader.APPROVE.SITE_PAGE"
      });
    case 'LANDING_PAGE':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalModalHeader.APPROVE.LANDING_PAGE"
      });
    case 'BLOG_POST':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalModalHeader.APPROVE.BLOG_POST"
      });
    case 'DEAL':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalModalHeader.APPROVE.DEAL"
      });
    case 'KNOWLEDGE_ARTICLE':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalModalHeader.APPROVE.KNOWLEDGE_ARTICLE"
      });
    default:
      throw new UnreachableI18nCaseError(approvalType);
  }
}